import moment from "moment/moment";
import { ColDef } from "ag-grid-community";

export const startDateComparatorFn: ColDef["comparator"] = (
  _,
  __,
  nodeA,
  nodeB,
) => {
  const prevDate = moment(nodeA?.data?.start_date);
  const currentDate = moment(nodeB?.data?.start_date);

  if (!nodeA?.data?.start_date || !nodeB?.data?.start_date) {
    return 0;
  }

  if (currentDate.isBefore(prevDate)) {
    return 1;
  }

  if (currentDate.isAfter(prevDate)) {
    return -1;
  }

  return 0;
};
